import React, { useMemo } from 'react';
import { LastResultItem } from '../lastResultItem';
import { uuid } from '../../helpers/uuid';
import { REC_BET_DATA_MODEL_MAP } from '../../enums/tableNumbers';
import { doChipStore } from '../../store/doChipStore';
import { useRouletteDoBetValidation } from '../../hooks/useRouletteDoBetValidation';
import { observer } from 'mobx-react-lite';
import { gameResultStore } from '@pascal/pascal-core/shared/core/store';
import { OptionBetPopUps } from '../optionBetPopUps';
import { gameStore } from '../../store/gameStore';

const RoundLastResults = observer(
  ({ setIsShowBetActionModal, isShowBetActionModal, handleMouseLeave, handleMouseMove }) => {
    const { isShowAutoPlay } = gameStore;
    const { selectedChip } = doChipStore;
    const { handleDoBetWithValid } = useRouletteDoBetValidation();

    const numberList = useMemo(() => {
      return gameResultStore.gameResults
        .filter((item) => item.roundData)
        .slice(0, 10)
        .map((item) => item.roundData.number);
    }, [gameResultStore.gameResults]);

    const handleDoChip = (e) => {
      const valueType = e.target.getAttribute('data');
      const model = REC_BET_DATA_MODEL_MAP[valueType];
      if (model) {
        const nextChipModel = {
          [model.type]: selectedChip,
          chipType: model.type,
        };
        if (selectedChip) {
          handleDoBetWithValid(nextChipModel);
        }
      }
    };

    return (
      <div className='right-cl-top-wrp'>
        <div
          className='numbers-title-wrp'
          onClick={handleDoChip}
          onMouseMove={handleMouseMove}
          onMouseLeave={handleMouseLeave}
        >
          {numberList.map((item, index) => (
            <LastResultItem lastResult={item} key={uuid()} index={index} />
          ))}
        </div>
        <OptionBetPopUps
          isShowAutoPlay={isShowAutoPlay}
          setIsShowBetActionModal={setIsShowBetActionModal}
          isShowBetActionModal={isShowBetActionModal}
        />
      </div>
    );
  }
);
export default RoundLastResults;
